import { history } from '../../../_configurations/history';

export const goto = (url: string): void => {
  history.replace(url);
};
